import api from '../api';

export const getAnalytics = payload =>
  api.request({
    url: 'analytics',
    method: 'GET',
    params: { country: payload },
  });
